module.exports = __webpack_public_path__ + "static/media/MZ_04.ba1471e6.jpg";